import styled from "styled-components";

export const TextArea = styled.textarea`
  font-size: ${props => props?.fontSize || '1rem'};
  font-weight: ${props => props?.fontWeight || 400};
  min-height: ${props => props?.minHeight || '10rem'};
  width: 100%;
  background-color: transparent;
  color: #f2f2f2;
  border: 1px solid #505050;
  padding: 0.5rem;
  border-radius: 0.25rem;
  resize: vertical;
  overflow: auto;
  width: 100%;
`;

export const Text = styled.p`
  margin: 0;
  white-space: pre-wrap;
  font-size: ${props => props?.fontSize || '1rem'};
  font-weight: ${props => props?.fontWeight || 400};
  font-family: Montserrat;
`;